import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastService } from '@shared/events/toast.service';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})

export class NotificacionesService {

    constructor(
        private toastService: ToastService,
        private _http: HttpClient
    ) { }

    public CrearNotificacion(Notificacion) {
        if(Notificacion.Evento === 'Successful'){
            this.toastService.toastSuccessful(Notificacion.Mensaje, Notificacion.Accion);
            return;
        }

        if(Notificacion.Evento === 'Info'){
            this.toastService.toastInfo(Notificacion.Mensaje, Notificacion.Accion);
            return;
        }

        if(Notificacion.Evento === 'Error'){
            this.toastService.toastError(Notificacion.Mensaje, Notificacion.Accion);
            return;
        }

        if(Notificacion.Evento === 'Warning'){
            this.toastService.toastWarning(Notificacion.Mensaje, Notificacion.Accion);
            return;
        }
    }

    getTiposNotificaciones(){
        return this._http.get<any>(`${environment.API_URL}/Notificaciones/Categorias`);
    }
}
